$(window).bind('load', function () {
    if ($('#js-location-map').length > 0) {
        $.ajaxSetup({
            cache: true
        });
        $.getScript("//maps.google.com/maps/api/js?loading=async&key=AIzaSyBgGGnejKEvX2-X-BZlC0yvowTJAGCpnzU&callback=initSingleMap");
    }
});

function initSingleMap() {
    var mapObj = $('#js-location-map');
    var latitude = parseFloat(mapObj.data('lat'));
    var longitude = parseFloat(mapObj.data('lng'));
    var zoom = parseInt(mapObj.data('zoom'));

    var map = new google.maps.Map(document.getElementById('js-location-map'), {
        zoom: zoom,
        center: {
            lat: latitude,
            lng: longitude
        }
    });

    var position = new google.maps.LatLng(latitude, longitude);

    var markerOptions = {
        map: map,
        position: position,
        animation: google.maps.Animation.DROP,
        icon: {
            url: '/resources/themes/nzhearing/build/images/black-ear-pin.png',
            scaledSize: new google.maps.Size(50, 50)
        }
    };

    var marker = new google.maps.Marker(markerOptions);
}

window.initSingleMap = initSingleMap;
